const LOCAL_STORAGE = {
  USER_TOKEN: "__XuserToken",
  USER_INFO: "__XuserInfo",
  CLASSIC_LEVEL_DATA: "__XclassicLevelData",
};

export { LOCAL_STORAGE };
